import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ShakeAnimationService {
  showErrorMessage: boolean = false;
  errorMessage:string = '';
  constructor() { }

  /**
   * Add shake animation and change border color
   */
  addShakeAnimation(className:string, callingType: string = "") {
    this.showErrorMessage = true;
    let element:any = document.getElementsByClassName(className);
    if (element && element.length > 0) {
      if (callingType) {
        element[0].classList.remove('data-error');
      } else {
        element[0].classList.add('shakeModelError');
        element[0].classList.add('data-error');
      }
      setTimeout(() => {
        if (element && element.length > 0) {
          element[0].classList.remove('shakeModelError');
        }
      }, 2000);
    }
  }

  /**
   * Reset All  error data 
   */
  removeClass(className:string) {
    let element:any = document.getElementsByClassName(className);
    let element2 :any = document.getElementsByClassName(className);
    if (element.length &&   element[0].classList.contains('data-error')) {
      element[0].classList.remove('data-error');
    } else {
      if (element2.length && element2[0].classList.contains('data-error')) {
        element2[0].classList.remove('data-error');
      }
    }
    
    this.showErrorMessage = false;
    this.errorMessage = "";
  }
}
